export default __webpack_public_path__ + "static/media/spooky-swap.7836d311.jpg";